<div #container class="collapsible" [class.expanded]="!collapsed" [class.collapsed]="collapsed" [style.height.px]="currentHeight">
  <ng-content></ng-content>
</div>
